import { InvoiceStatusGroups } from "@/data/enums/invoice";
import { RegexMatch } from "@/data/enums/router";
import InvoicesListing from "@/components/app/global/invoices/invoicesListing.vue";
import {
  InvoiceStatusParam,
  DefaultInvoicesFilters,
  InvoiceStatusFilter
} from "@/data/filters/invoice";
import { NavigationGuardNext, Route } from "vue-router";
import store from "@/store";

export default [
  {
    path: "account",
    components: {
      default: () => import("@/views/admin/account/index.vue")
    },
    props: {
      default: {
        routes: require("./menu").AccountRoutes
      }
    },
    meta: {
      title: "_.my_account"
    },
    children: [
      {
        path: "",
        name: "admin__account",
        redirect: "profile"
      },
      {
        path: "profile",
        name: "adminAccountProfile",
        component: () => import("@/views/admin/account/profile/index.vue"),
        meta: {
          title: "_.profile",
          backTo: "_.profile"
        }
      },
      {
        path: "email-history",
        name: "adminAccountEmailHistory",
        component: () => import("@/views/admin/account/emailHistory/index.vue"),
        meta: {
          title: "_.email_history",
          backTo: "_.email_history",
          auth: ["list_email_messages"]
        }
      },
      {
        path: "security",
        name: "adminAccountSecurity",
        component: () => import("@/views/admin/account/security/index.vue"),
        meta: {
          title: "_.security",
          backTo: "_.security"
        }
      },
      {
        path: "upmind",
        component: {
          name: "AdminUpmindAccount",
          template: `<router-view />`
        },
        meta: {
          mockClientContext: true
        },
        beforeEnter: async (
          to: Route,
          from: Route,
          next: NavigationGuardNext
        ) => {
          if (store.getters["user/isUpmindClient"]) return next();
          next(from.matched.length ? false : { name: "admin__account" });
          return store.dispatch("ui/endRouting");
        },
        children: [
          {
            path: "",
            name: "admin__upmindAccount",
            redirect: { name: "admin__upmindInvoices" }
          },
          {
            path: "invoices",
            name: "admin__upmindInvoices",
            redirect: { name: "admin__allUpmindInvoices" },
            component: () =>
              import("@/views/admin/account/upmind/invoices/index.vue"),
            props: {
              routes: require("./menu").UpmindInvoicesRoutes
            },
            meta: {
              title: "_.invoices",
              backTo: "_.upmind_invoices"
            },
            children: [
              {
                path: "all",
                name: "admin__allUpmindInvoices",
                component: InvoicesListing,
                props: {
                  availableFilters: () => [
                    ...DefaultInvoicesFilters(),
                    InvoiceStatusFilter()
                  ]
                }
              },
              {
                path: "paid",
                name: "admin__paidUpmindInvoices",
                component: InvoicesListing,
                props: {
                  manualFilters: () =>
                    InvoiceStatusParam(...InvoiceStatusGroups.PAID)
                },
                meta: {
                  title: "_.paid_invoices"
                }
              },
              {
                path: "unpaid",
                name: "admin__unpaidUpmindInvoices",
                component: InvoicesListing,
                props: {
                  manualFilters: () =>
                    InvoiceStatusParam(...InvoiceStatusGroups.UNPAID)
                },
                meta: {
                  title: "_.unpaid_invoices"
                }
              },
              {
                path: "credited",
                name: "admin__creditedUpmindInvoices",
                component: InvoicesListing,
                props: {
                  manualFilters: () =>
                    InvoiceStatusParam(...InvoiceStatusGroups.CREDITED)
                },
                meta: {
                  title: "_.credited_invoices"
                }
              },
              {
                path: `:invoiceId(${RegexMatch.UUID})`,
                component: {
                  name: "AdminUpmindInvoice",
                  /** `<router-view :key />` is required to prevent component re-use */
                  template: `<router-view v-bind="$attrs" :key='$route.params.invoiceId' />`
                },
                meta: {
                  title: "_.invoice_#",
                  breadcrumb: {
                    label: "_action.edit",
                    "vuex-key": "invoice"
                  }
                },
                props: true,
                children: [
                  {
                    path: "",
                    name: "admin__upmindInvoice",
                    components: {
                      default: () =>
                        import(
                          "@/views/admin/account/upmind/invoices/invoice/index.vue"
                        )
                    }
                  }
                ]
              },
              {
                path: "*",
                component: () => import("@/views/error/index.vue"),
                props: { code: 404 }
              }
            ]
          },
          {
            path: "tickets",
            component: {
              name: "AdminAccountTickets",
              template: `<router-view />`
            },
            meta: {
              title: "_.tickets"
            },
            children: [
              {
                path: "",
                name: "admin__upmindTickets",
                component: () =>
                  import("@/views/admin/account/tickets/index.vue"),
                meta: {
                  title: "_.my_tickets",
                  backTo: "_.my_tickets"
                }
              },
              {
                path: "add",
                name: "admin__addUpmindTicket",
                component: () =>
                  import("@/views/admin/account/tickets/ticket/index.vue"),
                meta: {
                  title: "_action.open_new_ticket",
                  backTo: "_action.open_new_ticket"
                }
              },
              {
                path: `:ticketId(${RegexMatch.UUID})`,
                name: "admin__upmindTicket",
                props: true,
                component: () =>
                  import("@/views/admin/account/tickets/ticket/details.vue"),
                meta: {
                  title: "_.manage_ticket"
                }
              }
            ]
          }
        ]
      },
      {
        path: "activity-log",
        name: "adminAccountActivityLog",
        component: () => import("@/views/admin/account/activityLog/index.vue"),
        meta: {
          title: "_.activity_log",
          backTo: "_.activity_log",
          auth: ["list_user_hook_logs"]
        }
      },
      {
        path: "*",
        component: () => import("@/views/error/index.vue"),
        props: { code: 404 }
      }
    ]
  }
];
